import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { Box } from "@remo-co/ui-core/src/components/Box";
import { Popover } from "@remo-co/ui-core/src/components/Popover";
import { Close } from "@remo-co/ui-core/src/icons/Close";
import { useI18n } from "i18n";
import ChangePlanButton from "modules/settings/plans/ChangePlanButton";
import { useCompanyPlanSettings } from "modules/companyPlanSettings";
import { useStyles } from "./styles";

interface Props {
  open: boolean;
  handleClose: () => void;
  buttonEl: HTMLButtonElement | null;
}

export const PurchaseAddonPopover = ({
  open,
  handleClose,
  buttonEl,
}: Props) => {
  const styles = useStyles();
  const { t } = useI18n(["eventDirectory"]);
  const { isAppsumoPlan } = useCompanyPlanSettings();

  return (
    <Popover
      open={open}
      anchorEl={buttonEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <Box data-testid="purchase-addon-popover" className={styles.content}>
        <Box className={styles.heading}>
          <Typography variant="h5">
            {t("eventDirectory:host.multilple.events")}
          </Typography>
          <Close
            fontSize="small"
            onClick={handleClose}
            className={styles.closeIcon}
            data-testid="close-icon"
          />
        </Box>
        <Typography variant="body1">
          {t("eventDirectory:current.plan.allows")}
          <br />
          <br />
          {t("eventDirectory:question.contact.support")}
        </Typography>

        {!isAppsumoPlan && (
          <Box className={styles.actionButton}>
            <ChangePlanButton
              variant="secondary"
              color="gray"
              text={t("eventDirectory:purchase.add.on")}
              size="sm"
            />
          </Box>
        )}
      </Box>
    </Popover>
  );
};
